<template>
    <div>
        <iframe src="https://www.luckyair.net//pssplus/frontend/8l/delay/delay_todelay.action?weight=100" style="width:100%; height: 800px;"  frameborder="0" scrolling="no" ></iframe>
    </div>
</template>

<script>
export default {
  data () {
    return {}
  },

  mounted () {},

  methods: {}
}
</script>
